import moment from "moment";
import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Divider, Grid } from "@material-ui/core";
import PlayArrow from "@material-ui/icons/PlayArrow";
import { withStyles } from "@material-ui/core/styles";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import { EMPTY_LIST } from "app/app.constants";
import { getCardWorkDays } from "features/planner/planner.actions";
import CalendarYear from "app/components/CalendarYear/CalendarYear";
import { getWorkDaysFromState } from "features/planner/planner.selectors";
import CalendarWorkDay from "features/planner/employee/components/CalendarWorkDay";
import { queryEmployeeWorkSchedules } from "features/planner/employee/employee.actions";

class EmployeeWorkScheduleCalendar extends PureComponent {
  constructor(props) {
    super(props);

    const now = moment();

    this.state = {
      startDate: now.clone().startOf("year"),
      endDate: now.clone().endOf("year"),
    };
  }

  componentDidMount() {
    const { startDate, endDate } = this.state;
    const { employeeCardId, dispatchQueryEmployeeWorkSchedules } = this.props;

    dispatchQueryEmployeeWorkSchedules(employeeCardId, startDate, endDate);
  }

  // Handle work schedule CRUDs
  componentDidUpdate(prevProps) {
    if (prevProps.workSchedules !== this.props.workSchedules) {
      const { startDate, endDate } = this.state;

      this.getCardWorkDays(startDate, endDate);
    }
  }

  onYearChange = (startDate, endDate) => {
    const { employeeCardId, dispatchQueryEmployeeWorkSchedules } = this.props;

    this.setState({
      startDate,
      endDate,
    });

    this.getCardWorkDays(startDate, endDate);
    dispatchQueryEmployeeWorkSchedules(employeeCardId, startDate, endDate);
  };

  getCardWorkDays = (startDate, endDate) => {
    const { employeeCardId, dispatchGetCardWorkDays } = this.props;

    dispatchGetCardWorkDays(employeeCardId, startDate, endDate);
  };

  DateRangeComponent = () => {
    const { classes } = this.props;

    return (
      <Grid container className={classes.rangeRoot}>
        <Divider
          classes={{
            root: classes.dateRangeDateRoot,
          }}
        />
      </Grid>
    );
  };

  DateRangeEndComponent = ({ date, displayStart }) => {
    const { classes } = this.props;

    return (
      <CalendarWorkDay date={date}>
        {displayStart && (
          <Divider
            classes={{
              root: classNames(
                classes.dateRangeDateRoot,
                classes.dateEndOfDateRange,
              ),
            }}
          />
        )}
        <FiberManualRecord className={classes.dateRangeIcon} />
      </CalendarWorkDay>
    );
  };

  DateRangeStartComponent = ({ date }) => {
    const { classes } = this.props;

    return (
      <CalendarWorkDay date={date}>
        <Divider
          classes={{
            root: classNames(
              classes.dateRangeDateRoot,
              classes.dateStartOfDateRange,
            ),
          }}
        />
        <PlayArrow className={classes.dateRangeIcon} />
      </CalendarWorkDay>
    );
  };

  render() {
    const { classes, workSchedules, initializeCreateWorkSchedule } = this.props;

    return (
      <Grid className={classes.root}>
        <CalendarYear
          year={this.state.year}
          dateRanges={workSchedules}
          DayComponent={CalendarWorkDay}
          onYearChange={this.onYearChange}
          DateRangeComponent={this.DateRangeComponent}
          onSelectDates={initializeCreateWorkSchedule}
          DateRangeEndComponent={this.DateRangeEndComponent}
          DateRangeStartComponent={this.DateRangeStartComponent}
        />
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    marginBottom: theme.spacing(5),
  },
  dateRangeDateRoot: {
    left: 1,
    right: 1,
    position: "absolute",
    background: "transparent",
    borderBottom: `1px dashed ${theme.altus.calendar.contrastColor}`,
  },
  dateEndOfDateRange: {
    left: 1,
    top: "50%",
    right: "50%",
  },
  dateStartOfDateRange: {
    right: 1,
    top: "50%",
    left: "50%",
  },
  dateRangeIcon: {
    top: "50%",
    width: "50%",
    height: "50%",
    left: "50%",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    color: theme.altus.calendar.contrastColor,
  },
  rangeRoot: {
    top: "50%",
    position: "absolute",
  },
});

EmployeeWorkScheduleCalendar.defaultProps = {
  workDays: EMPTY_LIST,
};

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      workDays: getWorkDaysFromState(state, employeeCardId),
    }),
    {
      dispatchGetCardWorkDays: getCardWorkDays,
      dispatchQueryEmployeeWorkSchedules: queryEmployeeWorkSchedules,
    },
  ),
  withStyles(styles),
)(EmployeeWorkScheduleCalendar);
